import { Fragment } from 'react';

import { useSession } from '../../contexts/session';

// Everything under it lives for one signed-in account, and starts afresh for
// the next (#136): signing out, signing in as someone else, or signing in
// again as the same person mounts it anew, so state kept for the last
// account, and work still queued for it, is never seen by the next one. A
// session read again for the same account, after a saved profile or a step
// of onboarding, keeps it.
export function AccountLifetime({ children }) {
  const { me } = useSession();
  let owner = 'nobody';

  if (me != null) {
    owner = me.id;
  }

  return <Fragment key={ owner }>{ children }</Fragment>;
}
